


/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {Chat} from '../../core/_models'

type Props = {
  chat: Chat
}

const UserStatuCell: FC<Props> = ({chat}) => {
 
 return (
 <>
  {chat.messages &&
     <span className='badge badge-light-primary fs-8 fw-bold'>{chat.messages.length.toString()}</span>
  }
  
 </>
 );

}

export {UserStatuCell}

